import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "plan-general-header"
}
const _hoisted_3 = {
  key: 0,
  class: "iatse-icon-info-circle-solid icon_rotate_0 icon_danger icon-tooltip fs-lg"
}
const _hoisted_4 = { class: "tooltip-text" }
const _hoisted_5 = { class: "text-underline plan-modal" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-down plan-modal" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "plan-general-detail-container__alert plan-general-detail-container__green flex-md-nowrap flex-wrap"
}
const _hoisted_8 = { class: "plan-general-detail-line" }
const _hoisted_9 = {
  key: 1,
  class: "plan-general-detail-container__alert plan-general-detail-container__red"
}
const _hoisted_10 = { class: "plan-general-detail-line" }
const _hoisted_11 = {
  key: 2,
  class: "plan-general-container plan-general-detail-container__alert flex-wrap"
}
const _hoisted_12 = { class: "plan-general-detail-line w-100" }
const _hoisted_13 = {
  key: 3,
  class: "plan-general-container"
}
const _hoisted_14 = { class: "plan-general-detail-line" }
const _hoisted_15 = { class: "plan-general-detail-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['plan-general-details', _ctx.classes])
  }, [
    (_ctx.title && _ctx.type === 'pension')
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h4", null, [
              _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
              (_ctx.info)
                ? (_openBlock(), _createElementBlock("i", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.info), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.actionButton)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "btn btn-primary plan-modal",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openProfileModal && _ctx.openProfileModal(...args)))
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.actionButton), 1),
                  _hoisted_6
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    (_ctx.multiple)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.items, (parentItem, parentIdx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "plan-general-container align-items-start",
            key: parentIdx
          }, [
            (parentIdx === 1 && _ctx.greenItems?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.greenItems, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["plan-general-detail-container", item.class || ''])
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h5", null, _toDisplayString(item.label), 1),
                          _createElementVNode("h4", {
                            class: _normalizeClass(item.itemClass || '')
                          }, _toDisplayString(item.value), 3)
                        ])
                      ], 2),
                      (index < _ctx.greenItems.length - 1 && _ctx.hasDivider)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['divider', { 'hide-mobile': index % 2 === 1 }])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.alert && parentIdx === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parentItem, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["plan-general-detail-container", item.class || ''])
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h5", null, _toDisplayString(item.label), 1),
                          _createElementVNode("h4", {
                            class: _normalizeClass(item.itemClass || '')
                          }, _toDisplayString(item.value), 3)
                        ])
                      ], 2),
                      (index < parentItem.length - 1 && _ctx.hasDivider)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['divider', { 'hide-mobile': index % 2 === 1 }])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parentItem, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["plan-general-detail-container", item.class || ''])
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("h5", null, _toDisplayString(item.label), 1),
                          _createElementVNode("h4", {
                            class: _normalizeClass(item.itemClass || '')
                          }, _toDisplayString(item.value), 3),
                          (item.modal)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "plan-modal text-underline text-primary w-100 mb-10 sm-fs-xs",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('recaptcha', 'Show SSN', 'modal-success')), ["prevent"]))
                              }, "Show SSN"))
                            : _createCommentVNode("", true)
                        ])
                      ], 2),
                      (index < parentItem.length - 1 && _ctx.hasDivider)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['divider', { 'hide-mobile': index % 2 === 1 }])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (parentIdx < _ctx.items.length - 1 && _ctx.hasMultipleDivider)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(['divider green-divider w-100', { 'hide-mobile': parentIdx % 2 === 1 }])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ]))
          ]))
        }), 128))
      : (_ctx.useContainer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["plan-general-detail-container", item.class || ''])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h5", null, _toDisplayString(item.label), 1),
                    _createElementVNode("h4", {
                      class: _normalizeClass(item.itemClass || '')
                    }, _toDisplayString(item.value), 3)
                  ])
                ], 2),
                (index < _ctx.items.length - 1 && _ctx.hasDivider)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(['divider', { 'hide-mobile': index % 2 === 1 }])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("div", {
                class: _normalizeClass(["plan-general-detail-container", item.class || ''])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h5", null, _toDisplayString(item.label), 1),
                  _createElementVNode("h4", null, _toDisplayString(item.value), 1)
                ])
              ], 2),
              (index < _ctx.items.length - 1 && _ctx.hasDivider)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['divider', { 'hide-mobile': index % 2 === 1 }])
                  }, null, 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
  ], 2))
}